import { render, staticRenderFns } from "./HelexSelect.vue?vue&type=template&id=1450d1d0&scoped=true"
import script from "./HelexSelect.vue?vue&type=script&lang=js"
export * from "./HelexSelect.vue?vue&type=script&lang=js"
import style0 from "./HelexSelect.vue?vue&type=style&index=0&id=1450d1d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1450d1d0",
  null
  
)

export default component.exports